@if (isNpiValidated) {
<span data-qa-id="readOnlyNpi">{{npiFormControl.value}}</span>
<div class="flex-row items-center" data-qa-id="npiVerified"><mat-icon class="check-circle"
        color="primary">check_circle</mat-icon><span class="highlighted-info">NPI # Verified</span></div>
} @else {
<mat-form-field class="app-form-field app-form-field-with-border">
    <input matInput data-qa-id="an_pi_npi_customcontrol" [formControl]="npiFormControl"
        [mask]="nationalProviderIdentifierMask" (input)="updateValue($event)" (blur)="onTouched()">
    @if (!npiFormControl.hasError('maxlength')) {
    <mat-hint>NPI# must be 10 digits</mat-hint>
    }
    @if (npiFormControl.hasError('required') && npiFormControl.touched) {
    <mat-error>
        NPI Number is required
    </mat-error>
    }
    @if (npiFormControl.hasError('pattern') && npiFormControl.touched) {
    <mat-error>
        NPI# must be 10 digits with no leading zeros
    </mat-error>
    }
    @if (npiFormControl.hasError('invalidNpi') && npiFormControl.touched) {
    <mat-error data-qa-id="invalid-npi-error">
        Invalid NPI
    </mat-error>
    }
</mat-form-field>
}